/**
 * Полёт фото товара в полосу корзины: добавленный с плитки товар летит по дуге к полосе над
 * вкладками. При «уменьшении движения» и без полосы на экране полёта нет.
 */
let target: HTMLElement | null = null;

/** Полоса корзины сообщает, куда лететь; с её уходом лететь некуда. */
export function setCartFlightTarget(element: HTMLElement | null): void {
  target = element;
}

export function launchCartFlight(photoUrl: string | null, from: HTMLElement | null): void {
  if (!photoUrl || !from) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const start = from.getBoundingClientRect();
  // Полосы ещё нет: первый товар. Она появится над вкладками по центру внизу.
  const end = target?.getBoundingClientRect() ?? new DOMRect(window.innerWidth / 2 - 20, window.innerHeight - 120, 40, 40);

  const image = document.createElement('img');
  image.src = photoUrl;
  image.className = 'cart-flight';
  image.style.left = `${start.left}px`;
  image.style.top = `${start.top}px`;
  image.style.width = `${start.width}px`;
  image.style.height = `${start.height}px`;
  document.body.append(image);

  const dx = end.left + 28 - (start.left + start.width / 2);
  const dy = end.top + end.height / 2 - (start.top + start.height / 2);
  const animation = image.animate(
    [
      { transform: 'translate(0, 0) scale(1)', opacity: 1 },
      { transform: `translate(${dx * 0.5}px, ${Math.min(dy * 0.2, -40)}px) scale(0.6)`, opacity: 1, offset: 0.45 },
      { transform: `translate(${dx}px, ${dy}px) scale(0.12)`, opacity: 0.4 },
    ],
    { duration: 520, easing: 'cubic-bezier(0.3, 0, 0.5, 1)' },
  );
  animation.finished.finally(() => image.remove());
}
